"use client";

import React, { useState, useEffect } from 'react';

export default function PopupSocio() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Verifica se o modal já foi fechado nesta sessão para não ficar incomodando toda hora
    const hasSeenPopup = sessionStorage.getItem('hasSeenPopupST');
    if (!hasSeenPopup) {
      // Pequeno delay para a página renderizar primeiro antes de pular o modal
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = (e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    setIsOpen(false);
    sessionStorage.setItem('hasSeenPopupST', 'true');
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[99999] flex items-center justify-center p-6 bg-black/80 backdrop-blur-sm"
      onClick={handleClose}
    >
      {/* Wrapper que ajusta seu tamanho exatamente ao conteúdo interno, com limite de altura de 85% da tela */}
      <div 
        className="relative inline-flex h-auto max-h-[85vh] max-w-[90vw] sm:max-w-[500px] animate-[pop_0.3s_ease-out]"
        onClick={(e) => e.stopPropagation()}
      >
        
        {/* Botão Fechar colado na quina da imagem */}
        <button 
          onClick={handleClose}
          className="absolute -top-3 -right-3 w-10 h-10 flex items-center justify-center bg-[#8A1538] text-white rounded-full hover:bg-red-700 transition-colors z-10 border-2 border-white shadow-xl cursor-pointer"
          title="Fechar"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="3">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Imagem com Link */}
        <a 
          href="https://nense.com.br/planos" 
          target="_blank" 
          rel="noopener noreferrer"
          className="block h-full w-full cursor-pointer rounded-2xl relative group"
          onClick={() => {
            sessionStorage.setItem('hasSeenPopupST', 'true');
            setIsOpen(false);
          }}
        >
          <img 
            src="https://cdn.nense.com.br/prod/assets/images/popup2.png" 
            alt="Seja Sócio Futebol" 
            className="w-auto h-full max-h-[85vh] object-contain rounded-2xl drop-shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-300"
          />
        </a>

      </div>
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes pop {
          0% { transform: scale(0.9); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}} />
    </div>
  );
}
